// Odoo generates unsubscribe links with an underscore in the final segment
// (/mailing/72/confirm_unsubscribe), so the route string overrides the
// kebab-case directory name to match the external URL exactly.
export default '/mailing/@id/confirm_unsubscribe';
